import _ from 'lodash';

import * as constants from './Survey.constants';
import * as services from './Survey.service';

const state = {
  survey: {},

  res_makeSurveyNew: {},
  res_checkSurveyHasposted: {},
};

const mutations = {
  [constants.GET_SURVEY_SUCCESS](state, survey) {
    if (undefined !== survey && null !== survey) {
      state.survey = {
        ...survey,
        itemList: _.map(survey.itemList, (item) => ({
          ...item,
          i_isReady: false,
        })),
      };
    }
  },

  [constants.UPDATE_SURVEY_ITEM](state, surveyItem) {
    state.survey = {
      ...state.survey,
      itemList: _.map(state.survey.itemList, (item) => {
        return item.surveyItemId === surveyItem.surveyItemId
          ? {
            ...item,
            ...surveyItem,
          } : item;
      }),
    };
  },

  [constants.RESET_SURVEY_ITEM](state) {
    state.survey = {
      ...state.survey,
      itemList: _.map(state.survey.itemList, (item) => ({
        ...item,
        i_isReady: false,
      })),
    };
  },

  [constants.MAKE_SURVEY_NEW_SUCCESS](state, res_makeSurveyNew) {
    state.res_makeSurveyNew = res_makeSurveyNew;
  },

  [constants.CHECK_SURVEY_HAS_POSTED_SUCCESS](state, res_checkSurveyHasposted) {
    state.res_checkSurveyHasposted = res_checkSurveyHasposted;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getSurvey({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getSurvey(payload);
    commit(constants.GET_SURVEY_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async makeSurveyNew({ commit }, payload) {
    const res = await services.makeSurveyNew(payload);
    commit(constants.MAKE_SURVEY_NEW_SUCCESS, {
      data: res.data.data,
      message: res.data.message,
    });
  },

  async makeEsgSurveyNew({ commit }, payload) {
    const res = await services.makeEsgSurveyNew(payload);
    commit(constants.MAKE_SURVEY_NEW_SUCCESS, {
      data: res.data.data,
      message: res.data.message,
    });
  },

  async checkSurveyHasposted({ commit }, payload) {
    const res = await services.checkSurveyHasposted(payload);
    commit(constants.CHECK_SURVEY_HAS_POSTED_SUCCESS, res.data.data);
  },
};

const getters = {
  survey: (state) => state.survey,

  isSurveyReady: (state, getters) => {
    const readyItemList = _.filter(
      getters.survey.itemList,
      (item) => item.i_isReady && 'hide' !== item.surveyItemType
    );
    return 0 < readyItemList.length;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
